import React from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import logo from '../assets/logoWithName.png'

const RightMenuDrawer = ({ open, onClose, driverName, onLogout }) => {
    return (
        <>
            {open && <div className="menu-overlay" onClick={onClose} />}
            <div className={`left-menu ${open ? "open" : ""}`}>
                <div className="menu-profile">
                    <img src={logo} alt="Logo" style={{ width: '200px', height: 'auto' }} />
                    <div style={{ color: 'gray' }}>Driver Name</div>
                    <div className="profile-name">
                        {driverName || "Driver"}
                    </div>
                </div>
                <div className="menu-items">
                    <div className="menu-item active">
                        Assigned Trips
                    </div>
                </div>
                <div className="menu-logout" onClick={onLogout}>
                    <ExitToAppIcon className="logout-icon" />
                    <span className="logout-text">Logout</span>
                </div>
            </div>
        </>
    );
};

export default RightMenuDrawer;
